import * as React from 'react';
import { Platform } from 'react-native';
import {
  createStackNavigator,
  StackNavigationProp
} from '@react-navigation/stack';
import MyStudiesScreen from '../screens/my-studies/MyStudiesScreen';
import StudyView from '../screens/study/StudyScreen';
import StudyEditScreen from '../screens/study/StudyEditScreen';
import StudyGeneratorIntroScreen from '../screens/study-generator/StudyGeneratorIntroScreen';
import CreateStudyScreen from '../screens/study-generator/CreateStudyScreen';
import StudyComingSoonScreen from '../screens/study-generator/StudyComingSoonScreen';
import FormTemplateScreen from '../screens/form-template/FormTemplateScreen';
import StudyEventFormScreen from '../screens/study/StudyEventFormScreen';
import { DrawerParamList } from './DrawerNavigator';
import AppHeader from '../components/AppHeader';
import { getScreenOptions } from './getScreenOptions';
import { StackActions, useNavigation } from '@react-navigation/native';

export type StudiesParamList = {
  FormTemplate: DrawerParamList['FormTemplate'];
};

const ModalStack = createStackNavigator<StudiesParamList>();

export default function ModalNavigator() {
  const navigation = useNavigation<StackNavigationProp<any>>();
  return (
    <ModalStack.Navigator
      initialRouteName='FormTemplate'
      screenOptions={({ route }) => ({
        ...getScreenOptions(route),
        header: () => (
          <AppHeader
            disableNavigation
            // onQuestionPressed={() => {
            //   // TODO: navigate to FAQ
            // }}
            onClose={() => {
              // navigate to previous screen prior to modal navigator
              const { fromStudyScreen } = route.params;
              const navigationState = navigation.getState();
              // console.log('navigationState', navigationState);
              let popCount = 0;
              for (let i = navigationState.routes.length - 1; i >= 0; i--) {
                if (navigationState.routes[i].name !== 'ModalNavigator') {
                  if (fromStudyScreen) {
                    navigation.dispatch(
                      StackActions.replace('DrawerNavigator', {
                        screen: 'BottomTabNav',
                        params: {
                          screen: 'StudiesNav'
                        }
                      })
                    );
                  } else {
                    navigation.pop(popCount);
                  }
                  return;
                }
                popCount++;
              }
            }}
          />
        ),
        headerShown: true,
        gestureEnabled: false,
        animationEnabled: Platform.select({
          ios: true,
          android: false
        })
      })}
    >
      {/* <ModalStack.Group
        screenOptions={{
          presentation: 'modal'
        }}
      ></ModalStack.Group> */}
      <ModalStack.Screen name='FormTemplate' component={FormTemplateScreen} />
    </ModalStack.Navigator>
  );
}
